import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {AnalyticsInjectorService} from 'shared/services/analytics/analytics.injector.service';
import {DataService} from 'shared/services/data.service';
import {MatDialog} from '@angular/material/dialog';
import {PendingChangesDialogComponent} from '../pending-changes-dialog/pending-changes-dialog.component';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LandingPageGuard implements CanActivate {
  constructor(
    private readonly dataService: DataService,
    private readonly analyticsInjector: AnalyticsInjectorService,
    private readonly router: Router,
    private readonly dialog: MatDialog
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const hasData = await this.dataService.hasData();
    if (hasData) {
      this.analyticsInjector.init('Logib - Navigation not allowed');
      const dialogRef = this.dialog.open(PendingChangesDialogComponent, {
        data: {}
      });
      const result = await firstValueFrom(dialogRef.afterClosed());
      if (result) {
        this.dataService.resetData();
        return true;
      }
      return false;
    }
    return true;
  }
}
